<template lang="pug">
  a.headline(:href="link" target="_blank" )
    span.theLink.pb-1 {{text}}
</template>

<script>
export default {
  props: ['link', 'text']
};
</script>

<style lang="stylus" scoped>
.headline
  text-decoration none

.theLink
  border-bottom 1px solid #000000
  color var(--v-primary-darken2)

.theLink:hover
  border-bottom 1px solid rgba(0, 0, 0, 0)
  color var(--v-info-darken2)
</style>
